import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { FiMenu, FiX, FiSearch, FiShield, FiBell } from 'react-icons/fi';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navItems = [
    { name: 'Latest News', path: '/news' },
    { name: 'Safety Alerts', path: '/alerts' },
    { name: 'Product Database', path: '/products' },
    { name: 'Resources', path: '/resources' },
  ];

  return (
    <header className="bg-surface border-b border-gray-100 sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-24">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group">
            <div className="bg-primary text-white p-2.5 rounded-full transition-transform group-hover:rotate-12">
              <FiShield size={26} />
            </div>
            <div className="flex flex-col">
              <span className="text-2xl font-serif font-black text-primary-dark tracking-tight">
                MORINGA<span className="text-primary-light italic">ALERT</span>
              </span>
              <span className="text-[10px] text-gray-400 font-bold uppercase tracking-[0.2em]">
                Consumer Safety Journal
              </span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-10">
            {navItems.map((item) => (
              <NavLink 
                key={item.name} 
                to={item.path}
                className={({ isActive }) => 
                  `text-sm font-bold uppercase tracking-widest transition-all hover:text-primary-light ${
                    isActive ? 'text-primary border-b-2 border-primary-light pb-1' : 'text-gray-500'
                  }`
                }
              >
                {item.name}
              </NavLink>
            ))}
            <div className="h-6 w-[1px] bg-gray-200 mx-2"></div>
            <button className="text-gray-400 hover:text-primary transition-colors">
              <FiSearch size={20} />
            </button>
            <Link 
              to="/alerts" 
              className="bg-primary-dark text-white px-6 py-2.5 rounded font-bold text-xs uppercase tracking-widest hover:bg-primary transition-all shadow-journal"
            >
              Report Issue
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button className="lg:hidden text-primary" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <FiX size={28} /> : <FiMenu size={28} />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      {isOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100 absolute w-full shadow-2xl animate-fade-in">
          <div className="flex flex-col p-6 gap-6">
            {navItems.map((item) => (
              <Link 
                key={item.name} 
                to={item.path} 
                className="text-lg font-bold text-gray-800 border-b border-gray-50 pb-2"
                onClick={() => setIsOpen(false)}
              >
                {item.name}
              </Link>
            ))}
            <Link 
              to="/alerts" 
              className="bg-primary text-center text-white py-4 rounded font-bold uppercase tracking-widest"
              onClick={() => setIsOpen(false)}
            >
              Report a Safety Issue
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;